import React from 'react';

const DeviceBrandTitle = ({ record }) => {
	return <span>DeviceBrand {record ? `"${record.name}"` : ''}</span>;
};
export default DeviceBrandTitle;
